export const fbKey = 'fbKey'

export const fbData = 'fbData'
